/**
 * Hunarvar Article — ToC + Sidebar Reordering + Scrollspy + Share Buttons
 * Eingebunden ueber sections/main-article-hunarvar.liquid.
 *
 * Verhalten:
 * 1. Sidebar-Reordering (nur Desktop >= 1024px): verschiebt .hn-toc,
 *    .hn-author-card und .hn-article-share aus dem Body in die
 *    .hn-article-sidebar, sodass der User im HTML-Editor die natuerliche
 *    Mobile-Reihenfolge schreibt und Desktop automatisch ein 2-Spalten-
 *    Layout bekommt.
 * 2. Active-State Scrollspy via IntersectionObserver: markiert den jeweils
 *    aktuell sichtbaren H2-Abschnitt im ToC mit .hn-toc__link--active.
 * 3. Share-Buttons URL-Filling: Wenn der User nur einen leeren
 *    <div class="hn-article-share"></div> schreibt, rendert das Skript
 *    das ARTIKEL-TEILEN-Eyebrow + 4 Share-Buttons (Twitter, Pinterest,
 *    Facebook, E-Mail) mit der aktuellen URL.
 * 4. Mobile-ToC-Toggle: Button .hn-toc__toggle togglet .hn-toc--collapsed
 *    auf dem Wrapper.
 *
 * Guard-Clause: tut nichts, wenn keine .hn-toc im DOM ist.
 */
(function () {
  'use strict';

  var toc = document.querySelector('.hn-toc');
  if (!toc) return;

  // === 1. Sidebar-Reordering (Desktop >= 1024px) =====================
  var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  var sidebar = document.querySelector('.hn-article-sidebar');
  if (isDesktop && sidebar) {
    ['.hn-toc', '.hn-author-card', '.hn-article-share'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el.parentElement !== sidebar) {
        sidebar.appendChild(el);
      }
    });
  }

  // === 2. Active-State Scrollspy =====================================
  var tocLinks = toc.querySelectorAll('a[href^="#"]');
  var headings = [];
  for (var i = 0; i < tocLinks.length; i++) {
    var hash = tocLinks[i].getAttribute('href');
    if (hash && hash.length > 1) {
      var target = document.getElementById(hash.slice(1));
      if (target) headings.push(target);
    }
  }

  if (headings.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            tocLinks.forEach(function (a) {
              var isActive = a.getAttribute('href') === '#' + id;
              a.classList.toggle('hn-toc__link--active', isActive);
            });
          }
        });
      },
      {
        rootMargin: '-15% 0px -75% 0px',
        threshold: 0,
      }
    );
    headings.forEach(function (h) {
      observer.observe(h);
    });
  }

  // === 3. Share-Buttons URL-Filling ==================================
  var shareWrap = document.querySelector('.hn-article-share');
  if (shareWrap && shareWrap.querySelectorAll('.hn-share-btn').length === 0) {
    var url = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);

    // Article-Featured-Image fuer Pinterest-Pin-Vorschlag (aus og:image-Meta).
    // Wenn vorhanden, gibt der Pin-Dialog dieses Bild als Default-Pin-Image vor —
    // sonst muesste der Leser selbst ein Bild auswaehlen.
    var ogImage = document.querySelector('meta[property="og:image"]');
    var media = ogImage ? encodeURIComponent(ogImage.getAttribute('content')) : '';
    var pinterestUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&description=' + title;
    if (media) pinterestUrl += '&media=' + media;

    // Inline-SVG-Icons (24x24 viewBox, fill: currentColor — werden via CSS-color
    // eingefaerbt). Aktuell nur Pinterest aktiv. Falls Twitter/Facebook/Mail
    // wieder dazu sollen: SVG-Code aus dem Git-Verlauf von Commit 144057c holen.
    var iconPinterest =
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>' +
      '</svg>';

    shareWrap.insertAdjacentHTML(
      'beforeend',
      '<span class="hn-eyebrow hn-eyebrow--inline">Artikel teilen</span>' +
        '<a class="hn-share-btn" href="' + pinterestUrl + '" target="_blank" rel="noopener" aria-label="Auf Pinterest teilen">' + iconPinterest + '</a>'
    );
  }

  // === 4. Mobile-ToC-Toggle ==========================================
  var toggleBtn = toc.querySelector('.hn-toc__toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      var isCollapsed = toc.classList.toggle('hn-toc--collapsed');
      toggleBtn.textContent = isCollapsed ? '+' : '−'; // unicode minus
      toggleBtn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
    });
  }
})();
